// extracted by css-extract-rspack-plugin
export default {"content":"content-ZevZRg flex justify-center items-center","logoImage":"logoImage-m_KY_S","phoneNumber":"phoneNumber-hdCqOd"};